import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Loader2, ShieldCheck } from 'lucide-react';

const AdminLogin = () => {
    const [formData, setFormData] = useState({ userName: '', password: '' });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => { 
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/adminworkspace001marvelsato/marvel-sato-management/login`, formData);
            if (res.data.success) {
                localStorage.setItem('adminToken', res.data.token);
                navigate('/admin');
            }
        } catch (err) {
            alert("Unauthorized Access: Wrong credentials!");
            console.log(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6 relative overflow-hidden">
            {/* Background Decorative Elements */}
            <div className="absolute top-[-10%] left-[-10%] w-72 h-72 bg-orange-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-slate-800/20 rounded-full blur-3xl"></div>

            <div className="w-full max-w-md z-10">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-orange-500 mb-4 shadow-lg shadow-orange-500/20">
                        <ShieldCheck size={32} className="text-white" />
                    </div>
                    <h2 className="text-3xl font-black text-white italic tracking-tighter uppercase">
                        SATO <span className="text-orange-500 text-4xl">.</span> INTERNAL
                    </h2>
                    <p className="text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em] mt-2">
                        Control Panel Access
                    </p>
                </div>

                <form onSubmit={handleLogin} className="bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl">
                    <div className="space-y-4">
                        <div className="relative">
                            <User className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
                            <input 
                                required
                                className="w-full bg-slate-950 border border-slate-800 text-white p-4 pl-12 rounded-xl focus:outline-none focus:border-orange-500 transition-all placeholder:text-slate-600 font-medium"
                                placeholder="Admin Username"
                                onChange={(e) => setFormData({...formData, userName: e.target.value})}
                            />
                        </div>

                        <div className="relative">
                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
                            <input 
                                required
                                type="password"
                                className="w-full bg-slate-950 border border-slate-800 text-white p-4 pl-12 rounded-xl focus:outline-none focus:border-orange-500 transition-all placeholder:text-slate-600 font-medium"
                                placeholder="Secret Password"
                                onChange={(e) => setFormData({...formData, password: e.target.value})}
                            />
                        </div>
                    </div>

                    <button 
                        disabled={loading}
                        className="w-full bg-orange-500 text-white py-4 rounded-xl font-black uppercase tracking-widest mt-8 hover:bg-orange-600 active:scale-95 transition-all shadow-lg shadow-orange-500/20 flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <>
                                <Loader2 className="animate-spin" size={20} />
                                Authenticating
                            </>
                        ) : (
                            "Authorize Login"
                        )}
                    </button>

                    <div className="mt-8 text-center">
                        <p className="text-slate-600 text-[9px] font-bold uppercase tracking-widest">
                            Secure & Encrypted 
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;